import { Client } from "@microsoft/microsoft-graph-client";
import { getGraphToken } from "./TokenService";
import "isomorphic-fetch";

export async function getGraphClient() {
  try {
    // Get a fresh token using the TokenService
    const accessToken = await getGraphToken();
    console.log('Got fresh Graph token for client initialization');
    
    // Initialize the Graph client with the token
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken);
      }
    });
    
    return client;
  } catch (error) {
    console.error("Error initializing Graph client:", error);
    throw error;
  }
}